import { environment } from '../environments/environment';

export const FixedRoutes = {
  Root: '',
  Auth: 'auth',
  Lock: 'lock',
  SignUp: 'signup',
  ResetPass: 'reset',
  ForgotPass: 'forgot',

  Dashboard: 'dashboard',
  Company: {
    Url: 'company',
    Directory: 'directory',
    Departments: 'departments',
    Designations: 'designations',
    Holiday: 'holiday',
  },
  Employee: {
    Url: 'employee',
    Directory: 'directory',
    Credential: 'credential',
    Role: 'role',
    Notice: 'notice',
  },
  Profile: {
    Url: 'profile',
    Personal: 'personal',
    Education: 'education',
    BankInfo: 'bankinfo',
    Documents: 'documents',
    Timeline: 'timeline',
  },
  Settings: {
    Url: 'settings',
    Keygroup: 'keygroup',
    Navigation: 'navigation',
    Permission: 'permission',
    Role: 'role',
    UserRole: 'userrole',
  },
  Shift: {
    Url: 'shift',
    Directory: 'directory',
    Roster: 'roster',
  },
  Attendance: {
    Url: 'attendance',
    // Dailypunching: 'dailypunching',
    Dailypunching: 'daily',
    Monthly: 'monthly',
    Attendancelog: 'attendancelog',
  },
  Leave: {
    Url: 'leave',
    Directory: 'directory',
    History: 'history',
    Balance: 'balance',
    Apply: 'apply'
  },

  Calendar: 'calendar',
  Onboarding: 'onboarding',
  Payroll: 'payroll',

  Wildcard: '**',
};

export const Modules = {
  Base: environment.apiURL,
  File: `${environment.apiURL}file`,
  OnboardFile: `${environment.apiURL}api/Onboard/upload`,
  Store: `${environment.apiURL}store`,
  Auth: `${environment.apiURL}api/auth`,
  Reset: `${environment.apiURL}api/auth/reset`,
  changePassword: `${environment.apiURL}api/Auth/ChangePassword`,
  Option: `${environment.apiURL}api/option`,
  Navigation: `${environment.apiURL}api/navigation`,
  MyNavigation: `${environment.apiURL}api/mynavigation`,
  CompanyToken: `${environment.apiURL}api/auth/companytoken`,
  RoleNavigation: `${environment.apiURL}api/RoleNavigation`,
  EmployeeNavigation: `${environment.apiURL}api/EmployeeNavigation`,

  Dashboard: `${environment.apiURL}api/Dashboard`,
  MyPunching: `${environment.apiURL}api/MyPunching`,
  MyPunchingNotification: `${environment.apiURL}api/MyPunching/ClockOutNotification`,
  MyWorkingHour: `${environment.apiURL}api/MyPunching/GetWorkingHoursForToday`,
  MyProfile: `${environment.apiURL}api/MyProfile`,
  Roster: `${environment.apiURL}api/ShiftTemplate/Roster`,
  MyProfilePicture: `${environment.apiURL}api/MyProfile/Picture`,
  DailyPunching: `${environment.apiURL}api/Report/DailyPunching`,
  CompanyDepartment: `${environment.apiURL}api/CompanyDepartment`,

  MonthlyAttendance: `${environment.apiURL}api/Report/MonthlyAttendance`,
  MarkAttendance: `${environment.apiURL}api/Report/MarkAttendance`,
  FinalizePayroll: `${environment.apiURL}api/Payroll/FinalizePayroll`,
  DefinalizePayroll: `${environment.apiURL}api/Payroll/DefinalizePayroll`,
  GetPayroll: `${environment.apiURL}api/Payroll`,

  ForgotPassword: `${environment.apiURL}api/Auth/ForgotPassword`,
  EmployeeData: `${environment.apiURL}api/Employee`,
  Holidays: `${environment.apiURL}api/CompanyHoliday`,
  HrmsEmployee: `${environment.apiURL}api/Employee`,


  HrmsLeaveRequest: `${environment.apiURL}api/LeaveRequest`,
  EmployeeById: `${environment.apiURL}api/Employee`,
  PayRollHistory: `${environment.apiURL}api/Payroll/PayRollHistory`,
  LeaveApproval : `${environment.apiURL}api/LeaveApproval`,
  UpdateProfile : `${environment.apiURL}api/MyProfile/ApproveOrRejectEmployeeUpdate`,
  UpdateEducation : `${environment.apiURL}api/MyEducation/ApproveOrRejectEducationUpdate`,
  UpdateBank : `${environment.apiURL}api/MyBank/ApproveOrRejectBankUpdate`,
  Regularization : `${environment.apiURL}api/Regularization/ApproveOrRejectRegularization`,
  EarlyClockOut : `${environment.apiURL}api/MyPunching/ApproveOrRejectEmployeePunching`,
  UpdateDocument : `${environment.apiURL}api/MyDocument/ApproveOrRejectDocumentUpdate`,

  LeaveHistory : `${environment.apiURL}api/LeaveRequest/LeaveHistory`,

  Notification : `${environment.apiURL}api/Notification`,
};


export const RouteExtensions = {
  Download: 'download',
  GetPage: 'getpage',
  Image: 'images',
};

export const LeaveStatus = {
  Approved: 'Approved',
  Rejected: 'Rejected',
  Dismissed: 'Dismissed',
  Pending: 'Pending',
};


export const NotifyStatus = {
  LeaveApproval: 'LeaveApproval',
  CompanyDocument: 'CompanyDocument',
  PersonalInfo: "PersonalInfo",
  EmployeeEducation: "EmployeeEducation",
  EmployeeBank: "EmployeeBank",
  EmployeePunching: "EmployeePunching",
  AttendanceRegularization: "AttendanceRegularization"
};
